<div class="dashboard min-vh-100 py-4 px-4">

  <div class="section-header d-flex justify-content-between align-items-center mb-3">
    <h2 class="section-title">Accès rapide</h2>
  </div>
  <!-- SECTION KPI (Cartes du haut de l'image) -->
  <section class="mb-4">
    <div class="row g-3">
      @for (item of dashboard; track $index) {
        @if (currentUser.user.profil[item.right]) {
          <div [class]="details.hasAttribute('hidden') ? 'col-12 col-md-4' : 'col-12 col-sm-6 col-md-4 col-xl-3'">
            <mat-card matRipple [matRippleCentered]="true" class="kpi-card h-100" appearance="outlined" (click)="goTo(item.path)">
              <mat-card-content class="d-flex align-items-center p-3">
                <div class="kpi-icon-wrapper me-3">
                  <img class="kpi-icon" [src]="item.img" alt="">
                </div>
                <div class="flex-grow-1 text-truncate">
                  <span class="kpi-label d-block text-truncate" [matTooltip]="item.title">{{ item.title }}</span>
                  <div class="d-flex align-items-baseline mt-1">
                    @if(loading()){
                      <mat-spinner diameter="20" class="spinner-light"></mat-spinner>
                    } @else {
                      <span class="kpi-value me-2">{{ item?.compteur }}</span>
                    }
                  </div>
                  <span class="kpi-subtext d-block text-truncate">{{ item.description }}</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }
      }
    </div>
  </section>

  <!-- SECTION GRAPHIQUE ET TABLEAUX (Style Épuré) -->
  <div [class]="currentUser.user.profil['owner'] ? 'row g-4' : 'row g-4 justify-content-end'" #details>
    
    <!-- Graphique : Production de la semaine -->
    <div class="col-12 col-lg-6">
      <div class="section-header d-flex justify-content-between align-items-center mb-3">
        <h2 class="section-title">Production de la semaine</h2>
        <span class="badge-count">{{ cpt }}</span>
      </div>
      @if (isDataLoaded()) {
        <mat-card class="content-panel p-2" appearance="outlined">
          <div class="chart-container p-2">
            <canvas class="m-2" baseChart [data]="chartData" [options]="chartOptions" type="bar"></canvas>
          </div>
        </mat-card>
      }
    </div>

    <!-- Classement de la semaine -->
    <div class="col-12 col-lg-6" [hidden]="!currentUser.user.profil['owner']">
      <div class="section-header mb-3">
        <h2 class="section-title">Classement de la semaine</h2>
      </div>
      <mat-card class="content-panel" appearance="outlined">
        @if (loading()) {
          <div class="panel-loading-overlay">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }
        <div class="table-scroll-wrapper">
          <table mat-table [dataSource]="dataSource" matSort class="w-100 premium-table">
            
            <ng-container matColumnDef="rang">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Rang </th>
              <td mat-cell *matCellDef="let row" data-label="Rang" class="text-center"> 
                <span class="rank-badge">{{getRank(row)}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="nb">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Rapport </th>
              <td mat-cell *matCellDef="let row" data-label="Rapport" class="fw-semibold text-accent"> 
                {{(row.rapport*100)?.toFixed(2)}} % 
              </td>
            </ng-container>

            <ng-container matColumnDef="site">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Bureaux </th>
              <td mat-cell *matCellDef="let row" data-label="Bureaux"> {{row.bureau}} </td>
            </ng-container>

            <ng-container matColumnDef="groupe">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Groupe </th>
              <td mat-cell *matCellDef="let row" data-label="Collaborateur" class="text-muted-light"> {{row.groupe_name}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center py-4 text-muted" colspan="4">Aucun résultat pour "{{searchValue()}}"</td>
            </tr>
          </table>
        </div>
        <mat-paginator #paginator [pageSizeOptions]="[5]" class="dark-paginator"></mat-paginator>
      </mat-card>
    </div>

    <!-- Production du jour -->
    <div class="col-12 col-lg-6">
      <div class="section-header d-flex justify-content-between align-items-center mb-3">
        <h2 class="section-title">Production du jour</h2>
        <span class="badge-count">{{ dataSourceAss.data.length }}</span>
      </div>
      <mat-card class="content-panel" appearance="outlined">
        @if (loading()) {
          <div class="panel-loading-overlay">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }
        <div class="table-scroll-wrapper">
          <table mat-table [dataSource]="dataSourceAss" matSort #sortAss class="w-100 premium-table">
            
            <ng-container matColumnDef="police">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Police </th>
              <td mat-cell *matCellDef="let row;" data-label="Police" class="fw-medium"> {{ row.police }} </td>
            </ng-container>

            <ng-container matColumnDef="attestation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Attestation </th>
              <td mat-cell *matCellDef="let row" data-label="Attestation"> {{ row.attestation }} </td>
            </ng-container>

            <ng-container matColumnDef="carte_rose">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Carte rose </th>
              <td mat-cell *matCellDef="let row" data-label="Carte rose"> {{row.carte_rose }} </td>
            </ng-container>

            <ng-container matColumnDef="compagnie_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Compagnie </th>
              <td mat-cell *matCellDef="let row" data-label="Compagnie"> 
                <span class="company-tag">{{row.compagnie_name}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="assure">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Assuré </th>
              <td mat-cell *matCellDef="let row" data-label="Assuré" class="text-truncate text-highlight" style="max-width: 140px;"> 
                {{row.assure ?? row.societe}} 
              </td>
            </ng-container>

            <ng-container matColumnDef="vehicule">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Véhicule </th>
              <td mat-cell *matCellDef="let row" data-label="Véhicule" class="text-muted-light"> {{row.vehicule }} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsAss; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsAss;"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center py-4 text-muted" colspan="6">Aucun résultat pour "{{searchValue()}}"</td>
            </tr>
          </table>
        </div>
        <mat-paginator #paginatorAss [pageSizeOptions]="[5]" class="dark-paginator"></mat-paginator>
      </mat-card>
    </div>

  </div>
